import React, { createContext, useState, useContext, useEffect,  } from 'react';
import moment, { Moment } from 'moment';
import { OrderBy,TypeViz,ApiResponseMinAndMaxDates,JourneyData } from './TypeDataviz';
import { DatavizBridgeCrud } from '../Datavizualization/api/DataVizCrud';
import { useFiltersEncodeSunburst } from '../Datavizualization/Sunburst/useFiltersEncodeSunburst';

function formatDate(date){
	return moment(date).format('YYYY/MM/DD');
}
	type DatavizPropiverContextType = {
	isLoading: boolean;
	limitOfAggregatedVisitorJourney: ApiResponseMinAndMaxDates | null;
	momentStartDate : Moment | null;
	handleSetMomentStartDate : (d:Moment | null)=>void;
	momentEndDate :Moment | null;
	handleSetMomentEndDate: (d:Moment | null )=>void;
	dataVizAggregate: JourneyData | null;
	metrictDatavizTypeSelected : TypeViz | null;
	handleChangeSelectDatavizMetrics: (typeViz: TypeViz) => void;
	formatDate : (d:Moment)=>string;
	$location:any;
	needToRefreshAngularJs: (b:boolean)=>void;
	orderBy:OrderBy | null;
	handleChangeSelectOrderBy : (OrderBy:OrderBy) => void;
	limitOfAggregatedIsLoading:boolean;
	tenants: [] | null;
	selectedTenant: string | null;
	handleSelectedTenant: (t:string)=>void;
	noDataForAccount : boolean;
	maxBranchesAtFirstDepth : number;
	handleChangesmaxBranchesAtFirstDepth: (maxBranchesAtFirstDepth:React.ChangeEvent<HTMLInputElement>)=>void;
	branchesDeclineFactor: number;
	handleChangebranchesDeclineFactor: (type: number) => void;
	};

	interface DatavizPropiverProps {
	children: React.ReactNode;
	$http?: any;
	$rootScope?: any;
	$routeParams?: any;
	AuthServices?: any;
	$location?: any;
	$timeout?: any;
	accountId: string;
	}

const ContextDataviz = createContext<DatavizPropiverContextType | undefined>(undefined);

export const useDataVizContext = () => {
	const contextValue = useContext(ContextDataviz);
	if (contextValue === undefined) {
		throw new Error('must be used within an insights element');
	}
	return contextValue;
};

export const ProductGlobalContextProvider: React.FC<DatavizPropiverProps> = ({
	children,
	$rootScope,
	accountId,
	$http,
	$timeout,
	$location
}) => {
	const {
		metricDataviz,
		needRefreshAngularJs,
		datesFilter,
		orderBySelect,
		tenantselect
	} = useFiltersEncodeSunburst();

	const [isLoadingTenants, setisLoadingTenants] = useState(true);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [limitOfAggregatedIsLoading, setlimitOfAggregatedIsLoading] = useState<boolean>(true);
	const [tenants, settenants] = useState<[] | null>(null);
	const [limitOfAggregatedVisitorJourney, setlimitOfAggregatedVisitorJourney] = useState<ApiResponseMinAndMaxDates | null>(null);
	const [momentStartDate, setMomentStartDate] = useState<Moment | null>(null);
	const [momentEndDate, setMomentEndDate] = useState<Moment | null>(null);
	const [dataVizAggregate, setdataVizAggregate] = useState<JourneyData | null>(null);
	const [metrictDatavizTypeSelected, setmetrictDatavizTypeSelected] = useState<TypeViz | null>(TypeViz.Pagetype);
	const [orderBy, setOrderBy] = useState<OrderBy | null>(null);
	const [selectedTenant, setselectedTenant] = useState<any>(null);
	const [noDataForAccount, setnoDataForAccount] = useState(false);
	const [maxBranchesAtFirstDepth, setmaxBranchesAtFirstDepth] = useState(8);
	const [branchesDeclineFactor, setbranchesDeclineFactor] = useState(0.5);
	const { 
		getLimitAggregatedVisitorJourneyForAccount,
		getAggregatedVisitorJourney,
		getTenantScore
	} =  DatavizBridgeCrud($rootScope, accountId, $timeout, $http);

	const handleSetMomentStartDate = (newDate: Moment | null) => {
		setMomentStartDate(newDate);
	};
	const handleSetMomentEndDate = (newDate: Moment | null) => {
		setMomentEndDate(newDate);
	};
	function handleChangeSelectDatavizMetrics(metric: TypeViz) {
		const sunburstStorage = localStorage.getItem('sunburstStorage');
		if(sunburstStorage){
			const newSunburst = JSON.parse(sunburstStorage);
			const reset = {...newSunburst, metricDataviz: metric};
			localStorage.setItem('sunburstStorage',JSON.stringify(reset));
		}else{
			localStorage.setItem('sunburstStorage',JSON.stringify({ metricDataviz: metric }));
		}
		setmetrictDatavizTypeSelected(metric);
		$location.search('metricDataviz', metric);
		needToRefreshAngularJs(true);
	}
	function handleChangeSelectOrderBy(order: OrderBy) {
		const sunburstStorage = localStorage.getItem('sunburstStorage');
		if(sunburstStorage){
			const newSunburst = JSON.parse(sunburstStorage);
			const reset = {...newSunburst, orderBy: order};
			localStorage.setItem('sunburstStorage',JSON.stringify(reset));
		}else{
			localStorage.setItem('sunburstStorage',JSON.stringify({ orderBy: order }));
		}
		setOrderBy(order);
		$location.search('orderBy', order);
		needToRefreshAngularJs(true);
	}

	function calculateStartDateAndEndDate(minStartDate: string, maxEndDate: string, maxAllowedDaysToRequest: number): {startDate: Moment, endDate: Moment} {
		const safeMaxDays = (!maxAllowedDaysToRequest || maxAllowedDaysToRequest > 365) ? 7 : maxAllowedDaysToRequest;
		const minStartMoment = moment(minStartDate, 'YYYY-MM-DD').isValid() ? 
			moment(minStartDate, 'YYYY-MM-DD') : moment().subtract(1, 'year');
		const maxEndMoment = moment(maxEndDate, 'YYYY-MM-DD').isValid() ? 
			moment(maxEndDate, 'YYYY-MM-DD') : moment();
		const currentDate = moment(); 
		let startDate = moment(currentDate).subtract(7, 'days');
		
		if (startDate.isBefore(minStartMoment)) {
			startDate = minStartMoment.clone();
		} 
	
		else if (startDate.isAfter(maxEndMoment)) {
			startDate = maxEndMoment.clone().subtract(safeMaxDays - 1, 'days');
			if (startDate.isBefore(minStartMoment)) {
				startDate = minStartMoment.clone();
			}
		}

		let endDate = startDate.clone().add(safeMaxDays - 1, 'days');

		if (endDate.isAfter(maxEndMoment)) {
			endDate = maxEndMoment.clone();
		}
		
		return { startDate, endDate };
	}
	function needToRefreshAngularJs(bool){
		$rootScope.$broadcast('resetAngularsJS',bool);
	}
	function handleSelectedTenant(tenantId) {
		const tenantN = tenantId === 'default' ? tenantId : tenants?.find(t => t === tenantId);
		
		const sunburstStorage = localStorage.getItem('sunburstStorage');
		if (tenantN) {
			setselectedTenant(tenantN);
			$location.search('tenant',null);
			$location.search('tenant',tenantN);
			if (sunburstStorage) {
				const newSunburst = JSON.parse(sunburstStorage);
				const reset = { ...newSunburst, tenant: tenantN };
				localStorage.setItem('sunburstStorage', JSON.stringify(reset));
			} else {
				localStorage.setItem('sunburstStorage', JSON.stringify({ tenant: tenantN }));
			}
		} else {
			$location.search('tenant',null);
			if (sunburstStorage) {
				const newSunburst = JSON.parse(sunburstStorage);
				const reset = { ...newSunburst, tenant: tenantN };
				localStorage.setItem('sunburstStorage', JSON.stringify(reset));
			} else {
				localStorage.setItem('sunburstStorage', JSON.stringify({ tenant: tenantN }));
			}
			console.error('Tenant not found');
		}
		
		needToRefreshAngularJs(true);
	}
	
	function getTenantScoreAccount(){
		getTenantScore((data)=>{
			setisLoadingTenants(false);
			settenants(data);
		},
		(err)=>{
			console.log('🚀 ~ getTenantScoreAccount ~ err:', err);
			setisLoadingTenants(false);
			settenants([]);
		}
		);
	}
	function handleChangesmaxBranchesAtFirstDepth(e: React.ChangeEvent<HTMLInputElement>) {
		setmaxBranchesAtFirstDepth(Number(e.target.value));
	}
	function handleChangebranchesDeclineFactor(number:number) {
		setbranchesDeclineFactor(number);
	}

	useEffect(() => {
		getTenantScoreAccount();
		setlimitOfAggregatedIsLoading(true);
		getLimitAggregatedVisitorJourneyForAccount((data: ApiResponseMinAndMaxDates) => {
			setlimitOfAggregatedIsLoading(false);
			setlimitOfAggregatedVisitorJourney(data);
			setnoDataForAccount(false);
		},
		() => {	
			setnoDataForAccount(true);
			setIsLoading(false);
			setlimitOfAggregatedIsLoading(false);
			setlimitOfAggregatedVisitorJourney(null);
		});
		
	}, []);

	function getAggregatedVisitorJourneyByDates(){
		// if(!metrictDatavizTypeSelected) return;
		if(noDataForAccount)return;
		let tenantForFilter = selectedTenant;
		if(selectedTenant === 'notenant'){
			tenantForFilter = null;
		}else if(selectedTenant === 'default'){
			tenantForFilter = 'default';
		}

		const filters = {
			type: metrictDatavizTypeSelected,
			startDate: moment(momentStartDate).format('YYYY-MM-DD'), 
			endDate: moment(momentEndDate).format('YYYY-MM-DD'), 
			orderBy: orderBySelect,
			orderByAsc: false,
			maxDepth: 5,
			maxBranchesAtFirstDepth: maxBranchesAtFirstDepth,
			branchesDeclineFactor: branchesDeclineFactor,
			tenant: tenantForFilter === 'default' ? '' : tenantForFilter,
		};
		setIsLoading(true);
		getAggregatedVisitorJourney(filters,
			(data:JourneyData )=>{
				setIsLoading(false);
				setdataVizAggregate(data);
				if (data.startDate && data.endDate) {
					const newStart = moment(data.startDate);
					const newEnd = moment(data.endDate);
					const isSameStart = momentStartDate && newStart.isSame(momentStartDate, 'day');
					const isSameEnd = momentEndDate && newEnd.isSame(momentEndDate, 'day');
					if (!isSameStart || !isSameEnd) {
						setMomentStartDate(newStart);
						setMomentEndDate(newEnd);
						const datesFrom = formatDate(newStart);
						const datesTo = formatDate(newEnd);
						$location.search('dates', `fromDate=${datesFrom},toDate=${datesTo}`);
					}
				}
			},
			()=>{
				setIsLoading(false);
			},
		);
	}
	useEffect(()=>{
		const handler = setTimeout(() => {
			if(momentEndDate && momentStartDate && 
			!limitOfAggregatedIsLoading 
			)
			{
				getAggregatedVisitorJourneyByDates();
			}
		},800);
		return () => {
			clearTimeout(handler);
		};
	}, [
		limitOfAggregatedIsLoading,
		isLoadingTenants,
		selectedTenant,
		noDataForAccount,
		maxBranchesAtFirstDepth,
		branchesDeclineFactor
	]
	);


	useEffect(() => {
		if (limitOfAggregatedVisitorJourney && !limitOfAggregatedIsLoading ) {

			if (needRefreshAngularJs) {
				$location.search('metricDataviz', metricDataviz);
				$location.search('dates', null);
				$location.search('orderBy', orderBySelect);
				if (datesFilter === null && limitOfAggregatedVisitorJourney) {
					const startDateAndEndDate = calculateStartDateAndEndDate(
						limitOfAggregatedVisitorJourney.minStartDate,
						limitOfAggregatedVisitorJourney.maxEndDate,
						limitOfAggregatedVisitorJourney.maxAllowedDaysToRequest
					);
					console.log('🚀 ~ useEffect ~ startDateAndEndDate:', startDateAndEndDate);
					const endDate = startDateAndEndDate.endDate;
					setMomentEndDate(endDate);
					setMomentStartDate(startDateAndEndDate.startDate);

					const datesFrom = formatDate(startDateAndEndDate.startDate);
					const datesTo = formatDate(endDate);
					$location.search('dates', `fromDate=${datesFrom},toDate=${datesTo}`);

					const sunburstStorage = localStorage.getItem('sunburstStorage');
					if (sunburstStorage) {
						const newSunburst = JSON.parse(sunburstStorage);
						const reset = { ...newSunburst, dates: `fromDate=${datesFrom},toDate=${datesTo}` };
						localStorage.setItem('sunburstStorage', JSON.stringify(reset));
					} else {
						localStorage.setItem('sunburstStorage', JSON.stringify({ dates: `fromDate=${datesFrom},toDate=${datesTo}` }));
					}
				} else {
					const minStartMoment = moment(limitOfAggregatedVisitorJourney.minStartDate, 'YYYY-MM-DD').startOf('day');
					const maxEndMoment = moment(limitOfAggregatedVisitorJourney.maxEndDate, 'YYYY-MM-DD').startOf('day');
					let filteredStartDate = moment(datesFilter.fromDate, 'YYYY/MM/DD').startOf('day');
					let filteredEndDate = moment(datesFilter.toDate, 'YYYY/MM/DD').startOf('day');

					// Ensure filteredStartDate is not after filteredEndDate
					if (filteredStartDate.isAfter(filteredEndDate)) {
						[filteredStartDate, filteredEndDate] = [filteredEndDate, filteredStartDate];
					}

					if (filteredStartDate.isBefore(minStartMoment) || filteredEndDate.isAfter(maxEndMoment)) {
						const startDateAndEndDate = calculateStartDateAndEndDate(
							limitOfAggregatedVisitorJourney.minStartDate,
							limitOfAggregatedVisitorJourney.maxEndDate,
							limitOfAggregatedVisitorJourney.maxAllowedDaysToRequest
						);
						console.log('🚀 ~ useEffect ~ startDateAndEndDate:', startDateAndEndDate);
						setMomentEndDate(startDateAndEndDate.endDate);
						setMomentStartDate(startDateAndEndDate.startDate);

						const datesFrom = formatDate(startDateAndEndDate.startDate);
						const datesTo = formatDate(startDateAndEndDate.endDate);
						$location.search('dates', `fromDate=${datesFrom},toDate=${datesTo}`);

						const sunburstStorage = localStorage.getItem('sunburstStorage');
						if (sunburstStorage) {
							const newSunburst = JSON.parse(sunburstStorage);
							const reset = { ...newSunburst, dates: `fromDate=${datesFrom},toDate=${datesTo}` };
							localStorage.setItem('sunburstStorage', JSON.stringify(reset));
						} else {
							localStorage.setItem('sunburstStorage', JSON.stringify({ dates: `fromDate=${datesFrom},toDate=${datesTo}` }));
						}
					} else {
						const datesFrom = formatDate(filteredStartDate);
						const datesTo = formatDate(filteredEndDate);
						$location.search('dates', `fromDate=${datesFrom},toDate=${datesTo}`);
						setMomentEndDate(filteredEndDate);
						setMomentStartDate(filteredStartDate);
					}
				}
				$location.search('tenant', tenantselect);
				if(tenants?.find(tenant => tenant === tenantselect)){
					setselectedTenant(tenantselect);
				}else{
					if(tenantselect === 'default'){
						setselectedTenant('default');
					}else{
						setselectedTenant('notenant');
					}
				}
				needToRefreshAngularJs(true);
			} 
			else {
				if (metricDataviz) {
					setmetrictDatavizTypeSelected(metricDataviz);
				}
				if (datesFilter) {
					const minStartMoment = moment(limitOfAggregatedVisitorJourney.minStartDate, 'YYYY-MM-DD').startOf('day');
					const maxEndMoment = moment(limitOfAggregatedVisitorJourney.maxEndDate, 'YYYY-MM-DD').startOf('day');
					let filteredStartDate = moment(datesFilter.fromDate, 'YYYY/MM/DD').startOf('day');
					let filteredEndDate = moment(datesFilter.toDate, 'YYYY/MM/DD').startOf('day');

					if (filteredStartDate.isAfter(filteredEndDate)) {
						[filteredStartDate, filteredEndDate] = [filteredEndDate, filteredStartDate];
					}

					if (filteredStartDate.isBefore(minStartMoment) || filteredEndDate.isAfter(maxEndMoment)) {
						const startDateAndEndDate = calculateStartDateAndEndDate(
							limitOfAggregatedVisitorJourney.minStartDate,
							limitOfAggregatedVisitorJourney.maxEndDate,
							limitOfAggregatedVisitorJourney.maxAllowedDaysToRequest
						);
						console.log('🚀 ~ useEffect ~ startDateAndEndDate:', startDateAndEndDate);
						setMomentEndDate(startDateAndEndDate.endDate);
						setMomentStartDate(startDateAndEndDate.startDate);

						const datesFrom = formatDate(startDateAndEndDate.startDate);
						const datesTo = formatDate(startDateAndEndDate.endDate);
						$location.search('dates', `fromDate=${datesFrom},toDate=${datesTo}`);

						const sunburstStorage = localStorage.getItem('sunburstStorage');
						if (sunburstStorage) {
							const newSunburst = JSON.parse(sunburstStorage);
							const reset = { ...newSunburst, dates: `fromDate=${datesFrom},toDate=${datesTo}` };
							localStorage.setItem('sunburstStorage', JSON.stringify(reset));
						} else {
							localStorage.setItem('sunburstStorage', JSON.stringify({ dates: `fromDate=${datesFrom},toDate=${datesTo}` }));
						}
					} else {
						setMomentEndDate(filteredEndDate);
						setMomentStartDate(filteredStartDate);
					}
				}
				if(orderBySelect){
					setOrderBy(orderBySelect);
				}
				if(tenantselect){
					if(tenants?.find(tenant => tenant === tenantselect)){
						setselectedTenant(tenantselect);
					}else{
						if(tenantselect === 'default'){
							setselectedTenant('default');
						}else{
							setselectedTenant('notenant');
						}
					}
				}
			}
		}
	}, [metricDataviz,
		datesFilter,
		limitOfAggregatedVisitorJourney,
		orderBySelect,
		limitOfAggregatedIsLoading,
		tenants,
		tenantselect,
	]);


	return (
		<ContextDataviz.Provider
			value={{
				isLoading,
				limitOfAggregatedVisitorJourney,
				handleSetMomentStartDate,
				momentStartDate,
				momentEndDate,
				handleSetMomentEndDate,
				dataVizAggregate,
				metrictDatavizTypeSelected,
				handleChangeSelectDatavizMetrics,
				formatDate,
				$location,
				needToRefreshAngularJs,
				orderBy,
				handleChangeSelectOrderBy,
				limitOfAggregatedIsLoading,
				tenants,
				handleSelectedTenant,
				selectedTenant,
				noDataForAccount,
				handleChangesmaxBranchesAtFirstDepth,
				handleChangebranchesDeclineFactor,
				maxBranchesAtFirstDepth,
				branchesDeclineFactor
				
			}}
		>
			{children}
		</ContextDataviz.Provider>
	);
};

export default ProductGlobalContextProvider;